import { render, staticRenderFns } from "./coinGameListModal.vue?vue&type=template&id=6b610acf&scoped=true"
import script from "./coinGameListModal.vue?vue&type=script&lang=js"
export * from "./coinGameListModal.vue?vue&type=script&lang=js"
import style0 from "./coinGameListModal.vue?vue&type=style&index=0&id=6b610acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b610acf",
  null
  
)

export default component.exports